'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const StatisticsPanelHelpers=require('../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ThresholdStatusDonutDirective=class ThresholdStatusDonutDirective extends BaseControllerBackedDirective{
get controller(){return ThresholdStatusDonutDirectiveController}
get objectBindings(){return['statusCounts','preventAnimations']}
get template(){
return`<svg id="{{::controller.panelId}}"></svg>`;
}};


const DefaultHeightAndWidth=100;
const ComponentPadding=10;
const InnerPadding=0;
const RingThickness=8;let

ThresholdStatusDonutDirectiveController=class ThresholdStatusDonutDirectiveController{
constructor($scope,$timeout,$element,elementService){
this._$scope=$scope;
this._$timeout=$timeout;
this._$element=$element;
this._elementService=elementService;
this._svgContainer=null;

this.preventAnimations=_.exists(this.preventAnimations)?this.preventAnimations:!1;

this.panelId='panel-'+Guid.create().toString();

const _debouncedRedraw=_.debounce(options=>$timeout(()=>this._redraw(options)),100);
const _redrawIfNew=(newVal,oldVal)=>{
if(!_.exists(newVal)||newVal===oldVal){
return;
}

_debouncedRedraw();
};

$scope.$watch('controller.statusCounts',_redrawIfNew);
$scope.$on('resize::resize',()=>_debouncedRedraw({isResizing:!0}));

_debouncedRedraw();
}

_redraw({isResizing=!1}={}){
const componentHeightAndWidth=Math.max(100,this.parentWrapperElement.clientHeight)-ComponentPadding*2;

if(isResizing&&this._lastComponentHeightAndWidth&&componentHeightAndWidth===this._lastComponentHeightAndWidth){
return;
}

this._setupGraphs(componentHeightAndWidth);
this._setupInitialState(isResizing);
this._updateState(isResizing);

this._lastComponentHeightAndWidth=componentHeightAndWidth;
}

get parentWrapperElement(){
return this._parentWrapperElement||(this._parentWrapperElement=this._elementService.selectElement(this._$element)[0].parentElement);
}

_setupGraphs(componentHeightAndWidth){
if(!_.exists(this._svgContainer)){
this._svgContainer=d3.select(`#${this.panelId}`);

this._graphAreaGroup=this._svgContainer.append('g').
attr({class:'graph-area'});
}

this._svgContainer.
attr(componentHeightAndWidth).
style('width',`${componentHeightAndWidth}px`).
style('height',`${componentHeightAndWidth}px`);

this._graphAreaGroup.
attr('transform',`translate(${componentHeightAndWidth/2},${componentHeightAndWidth/2})`);

this._drawArc=d3.svg.arc().
outerRadius(componentHeightAndWidth/2-InnerPadding).
innerRadius(componentHeightAndWidth/2-InnerPadding-RingThickness/DefaultHeightAndWidth*componentHeightAndWidth);
}

_setupInitialState(isResizing){
const formatted=_.toPairs(this.statusCounts).reverse().filter(([type,count])=>count>0);

this._dataArcs=this._graphAreaGroup.
attr({class:'graph-area arc'}).
selectAll('path').
data(pie(formatted),(d,i)=>Math.random());

this._dataArcs.
enter().
append('path').
attr({
d:this._drawArc,
class:d=>`${_getSegmentName(d).toLowerCase()}-threshold`});


if(isResizing||this.preventAnimations){
this._dataArcs.
exit().
remove();
return;
}

this._dataArcs.
exit().
transition().duration(StatisticsPanelHelpers.DefaultTransitionDuration).
each('end',_removeElement);
}

_updateState(isResizing){
const drawArc=this._drawArc;

if(isResizing||this.preventAnimations){
this._dataArcs.
attr('d',drawArc);
return;
}

this._dataArcs.
transition().
duration(StatisticsPanelHelpers.DefaultTransitionDuration).
attrTween('d',function(d){
const interpolate=d3.interpolate({
startAngle:0,
endAngle:0},
d);

return function(t){
return drawArc(interpolate(t));
};
});
}};


const _getSegmentName=d=>d.data[0];

const pie=d3.layout.pie().
sort(null).
value(d=>d[1]);


function _removeElement(){
if(typeof this.remove=='function'){
return this.remove();
}

if(_.exists(this.parentNode)){
return this.parentNode.removeChild(this);
}


}

module.exports=ThresholdStatusDonutDirective;
//# sourceMappingURL=thresholdStatusDonutDirective.js.map
